import { Modal } from "react-bootstrap"
import ButtonClose from "./ButtonClose"
import "./modal.css"

const ModalCobertura = (props) => {

    const handleClose = () => props.close(false)

    return (
        <>
             <Modal show={props.show} onHide={handleClose} size="lg" centered>
                <Modal.Body>
                    <ButtonClose close={handleClose} />
                    <div className='modal__groups'>
                        <div className="modal__group">
                            {/* <div className="cob__card-ico_container-mov-modal">
                                <img src={props.icon} alt="imagen cob icono" />
                            </div> */}
                            <div className="modal__descripcion">
                                <h3 className="modal__titulo" dangerouslySetInnerHTML={{__html: props.titulo.includes('<br/>') ? props.titulo.split('<br/>')[1] : props.titulo}}></h3>
                                <div className="d-block d-lg-none pb-4"></div>
                                <p dangerouslySetInnerHTML={{ __html:props.desc }} style={{fontSize: "18px"}}></p>
                            </div>
                            <div className="modal__descripcion">
                                <h3 style={{fontSize: "16px", fontWeight: 700}}>¿Qué no cubre tu seguro?</h3>
                                <ul style={{paddingLeft: props.coberturasDesc.length < 2 && 0, marginBottom: "5rem"}}>
                                {props.coberturasDesc.map((cobertura, index) => {
                                    return(
                                        <li style={{listStyle: props.coberturasDesc.length < 2 && 'none' }}>{cobertura.descripcionCobertura}</li>
                                    ) 
                                })}
                                </ul>
                                {/* <p dangerouslySetInnerHTML={{__html: props.coberturasDesc[0].descripcionCobertura}}></p> */}
                                <p style={{color: "#EC111A"}}>*Esta información muestra los aspectos más relevantes de tu seguro, te recomendamos revisar las Condiciones Generales del mismo.</p>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCobertura